import { z } from "zod";

export const toolPreviousValueSchema = z.object({
	id: z.number().nullable(),
	value: z.number(),
	invested: z.number().nullable(),
	date: z.string(),
});

export type ToolPreviousValue = z.output<typeof toolPreviousValueSchema>;
